import ViewPromotion from './ViewPromotion.vue'
import DiscountedProduct from './DiscountedProduct.vue'
import SpecialPromotionItem from './SpecialPromotionItem.vue'
import SelectableGrid from '../../components/SelectableGrid.vue'

export default {
  name: 'ViewEventItemsView',

  props: {
    eventStartDate: {
      type: String
    },
    eventEndDate: {
      type: String
    },
    customerGroups: {
      type: Array,
      required: true
    },
    discountedProducts: {
      type: Array
    },
    specialPromotions: {
      type: Array
    }
  },

  data () {
    return {
      promotionBeingViewed: null,
      viewPromotionShown: false
    }
  },

  computed: {
    totalRows () {
      return this.discountedProducts.length + this.specialPromotions.length
    }
  },

  components: {
    'view-promotion': ViewPromotion,
    'discounted-product': DiscountedProduct,
    'special-promotion': SpecialPromotionItem,
    'selectable-grid': SelectableGrid
  },

  methods: {
    scrollItems (event) {
      let elem = this.$refs.itemsTableWrapper
      let scrollMultiplier = event.target.scrollLeft / (event.target.scrollWidth - event.target.offsetWidth)
      elem.scrollLeft = (elem.scrollWidth - elem.offsetWidth) * scrollMultiplier
    },

    showPromotion (item) {

      this.promotionBeingViewed = item
      this.viewPromotionShown = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/ViewEvent/ViewEventItems.js